module.exports = __webpack_public_path__ + "static/media/sitemap_v_3.89aa55d5.svg";